import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Linkedin,
  Twitter,
  Instagram,
  Youtube,
  MapPin,
  Phone,
  Mail,
} from "lucide-react";

const SOCIAL = [
  { icon: Linkedin, href: "#", label: "LinkedIn" },
  { icon: Twitter, href: "#", label: "Twitter" },
  {
    icon: Instagram,
    href: "https://www.instagram.com/indianecofuels?igsh=MTFyNm9zcDF4bnV5Yw%3D%3D&utm_source=qr",
    label: "Instagram",
  },
  { icon: Youtube, href: "#", label: "YouTube" },
];

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer
      data-testid="main-footer"
      className="relative pt-24 pb-10 overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, #050A07 0%, #021A0E 50%, #001407 100%)",
      }}
    >
      {/* Glow Background */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-eco-light/60 to-transparent" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-eco-light/15 blur-[140px]" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 pb-14 border-b border-white/10">

          {/* Brand */}
          <div>
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                try {
                  navigate("/");
                } catch (err) {
                  try {
                    window.location.hash = "#/";
                  } catch (e) {}
                }

                setTimeout(() => {
                  const el2 = document.getElementById("home");
                  if (el2) el2.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 180);
              }}
              className="flex items-center gap-3"
            >
              <img
                src="/logo.png"
                alt="Indian Eco Fuels"
                className="h-14 md:h-16 w-auto object-contain drop-shadow-[0_0_20px_rgba(19,136,8,0.55)]"
              />
            </a>

            <p className="mt-5 text-sm text-white/60 leading-relaxed">
              Building India's integrated clean-energy backbone — from biofuels,
              Bio-CNG to sustainable mobility infrastructure.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-5 tracking-wide">
              Contact
            </h4>

            <div className="space-y-4 text-sm text-white/60">
              <a
                href="https://www.google.com/maps/search/?api=1&query=SCO+15+HSVP+Complex+Sector+4-5+Karnal+132001"
                target="_blank"
                rel="noreferrer"
                className="flex items-start gap-3 hover:text-eco-light transition-colors"
              >
                <MapPin className="w-4 h-4 mt-0.5 text-eco-light" />
                SCO 15, HSVP Complex, Sector 4-5, Karnal 132001
              </a>

              <a
                href="tel:+918930225999"
                className="flex items-center gap-3 hover:text-eco-light transition-colors"
              >
                <Phone className="w-4 h-4 text-eco-light" />
                +91 8930225999
              </a>

              <a
                href="mailto:contact@indianecofuels.co"
                className="flex items-center gap-3 hover:text-eco-light transition-colors"
              >
                <Mail className="w-4 h-4 text-eco-light" />
                contact@indianecofuels.co
              </a>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-semibold mb-5 tracking-wide">
              Follow Us
            </h4>

            <div className="flex gap-4">
              {SOCIAL.map((s, i) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="group relative w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-white/70 transition-all duration-300 hover:border-eco-light hover:text-eco-light hover:scale-110"
                >
                  {/* Glow ring */}
                  <span className="absolute inset-0 rounded-full scale-0 group-hover:scale-125 opacity-0 group-hover:opacity-100 transition-all duration-500 bg-eco-light/10 blur-md" />

                  {/* Icon */}
                  <s.icon className="w-4 h-4 relative z-10 transition-transform duration-300 group-hover:rotate-6" />
                </a>
              ))}
            </div>

            <p className="mt-6 text-xs text-white/40 leading-relaxed">
              Stay updated with our latest clean energy projects and infrastructure growth.
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Indian Eco Fuels. All rights reserved.</p>

          <div className="flex gap-6">
            <a href="#" className="hover:text-eco-light transition-colors">
              Privacy Policy
            </a>
            <Link to="/careers" className="hover:text-eco-light transition-colors">
              Careers
            </Link>
            <Link to="/terms" className="hover:text-eco-light transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}